import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';

import './QuickLinkSkeleton.scss';

import { QuickLinkSkeletonProps } from './QuickLinkSkeleton.types';

const QuickLinkSkeleton: React.FC<QuickLinkSkeletonProps> = ({ className, list }) => {

  return (
    <Card className={`relative p8 flex flex-column ${className}`}>
      <div className={`grid`}>
        {list.map((_, i) => (
          <Skeleton variant="rect" width={60} height={60} className="mb2 br1" />
        ))}
      </div>
    </Card>
  );
};

export default QuickLinkSkeleton;
export { QuickLinkSkeletonProps };
